export default {
  '上级机构名称':'上级机构名称',
  '本机构名称':'本机构名称',
  '机构代码':'机构代码',
  '管理员名称':'管理员名称',
  '管理员账号':'管理员账号',
  '设备激活码':'设备激活码',
  '学制':'学制',
  '编辑机构信息':'编辑机构信息',
  '机构名称':'机构名称',
  '机构类型':'机构类型',
  '地图选择':'地图选择',
  '经纬度':'经纬度',
  '密码':'密码',
  '选择地点':'选择地点',
  '关键词搜索':'关键词搜索',
  '请选择位置':'请选择位置',
  '全国':'全国',
  '地址：':'地址：',
  '区域':'区域',
  '上级机构':'上级机构',
  '机构通用管理密码':'机构通用管理密码',
  '设备部分功能的调试密码，非管理员账号的密码':'设备部分功能的调试密码，非管理员账号的密码',
}